import { render, staticRenderFns } from "./SendHistory.vue?vue&type=template&id=ad3d8bbc&scoped=true&"
import script from "./SendHistory.vue?vue&type=script&lang=js&"
export * from "./SendHistory.vue?vue&type=script&lang=js&"
import style0 from "./SendHistory.vue?vue&type=style&index=0&id=ad3d8bbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3d8bbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad3d8bbc')) {
      api.createRecord('ad3d8bbc', component.options)
    } else {
      api.reload('ad3d8bbc', component.options)
    }
    module.hot.accept("./SendHistory.vue?vue&type=template&id=ad3d8bbc&scoped=true&", function () {
      api.rerender('ad3d8bbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/SendHistory.vue"
export default component.exports